export function buildLabelledOptions(options: any[]) {
  const labelledOptionsList = [];
  options.forEach((opt) => {
    const labelledOption = { label: opt.name, value: opt.id };
    labelledOptionsList.push(labelledOption);
  });
  return labelledOptionsList;
}
